module.exports = __webpack_public_path__ + "assets/img/zcban.5e642c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pagesInvestment/zcban.png
// module id = y2kO
// module chunks = 128